import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { CustomInput } from 'reactstrap'
import _ from 'common-tools/LodashHelper'

class CheckListBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    options: pt.array.isRequired,
    textProp: pt.string.isRequired,
    valueProp: pt.string.isRequired,
    queryFieldSetup: pt.shape({
      Name: pt.string,
      Operator: pt.string,
      Group: pt.string
    }),
    inline: pt.bool.isRequired
  })

  static defaultProps = {
    options: [],
    textProp: 'Text',
    valueProp: 'Value',
    inline: false
  }

  onCheckChanged (checkName, event) {
    const { input: { value, onChange } } = this.props

    const newValues = _.clone(value)

    const isChecked = event.target.checked

    const checkIndex = _.indexOf(newValues, checkName)
    if (isChecked) {
      if (checkIndex === -1) {
        newValues.push(checkName)
      }
    } else {
      if (checkIndex > -1) {
        _.pullAt(newValues, [checkIndex])
      }
    }
    onChange(newValues)
  }

  renderOptions (inline, options, textProp, valueProp, fieldProps) {
    const { value, name, loading } = fieldProps

    return (
      <div>
        {_.map(options, (o, i) => {
          const valuePropValue = o[valueProp || 'Value']
          const textPropValue = o[textProp || 'Text']

          return <CustomInput key={valuePropValue} type='checkbox' checked={_.indexOf(value, valuePropValue) > -1} id={`${name}_${i}`} onChange={this.onCheckChanged.bind(this, valuePropValue)} label={textPropValue || valuePropValue}
            value={valuePropValue} inline={inline} />
        })}
      </div>
    )
  }

  render () {
    const { inline, options, textProp, valueProp, ...rest } = this.props

    return (
      <FieldLayoutBox {...rest}>
        {(fieldProps) => this.renderOptions(inline, options, textProp, valueProp, fieldProps) }
      </FieldLayoutBox>
    )
  }
};

export const CheckListBox = (props) => { return <Field {...props} component={CheckListBoxClass} /> } // eslint-disable-line
export default CheckListBox
